/* ============================================================
   SB WASH — Theme JavaScript
   Vanilla JS: scroll reveal, mobile menu, form submission
   ============================================================ */

(function () {
  'use strict';

  /* ── Scroll Reveal ─────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.reveal');
    if (!els.length) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ── Mobile Menu ───────────────────────────────────────── */
  function initMobileMenu() {
    var toggle = document.getElementById('menu-toggle');
    var mobileNav = document.getElementById('mobile-nav');
    var iconOpen = document.getElementById('menu-icon-open');
    var iconClose = document.getElementById('menu-icon-close');
    if (!toggle || !mobileNav) return;

    toggle.addEventListener('click', function () {
      var isOpen = mobileNav.classList.toggle('open');
      if (iconOpen) iconOpen.style.display = isOpen ? 'none' : 'block';
      if (iconClose) iconClose.style.display = isOpen ? 'block' : 'none';
    });

    // Close on nav link click
    mobileNav.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        mobileNav.classList.remove('open');
        if (iconOpen) iconOpen.style.display = 'block';
        if (iconClose) iconClose.style.display = 'none';
      });
    });
  }

  /* ── Quote Form (pro page) ─────────────────────────────── */
  function initQuoteForm() {
    var form = document.getElementById('quote-form');
    if (!form) return;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var nameVal = (form.querySelector('[name="nom"]') || {}).value || '';
      var successEl = document.getElementById('quote-success');
      var nameEl = document.getElementById('quote-success-name');
      if (successEl) {
        if (nameEl) nameEl.textContent = nameVal;
        form.style.display = 'none';
        successEl.style.display = 'flex';
      }
    });
  }

  /* ── Smooth anchor scroll (for #section links) ─────────── */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var target = e.target;
      // Walk up to find anchor
      while (target && target.tagName !== 'A') { target = target.parentElement; }
      if (!target) return;
      var href = target.getAttribute('href');
      if (!href || href.charAt(0) !== '#' || href.length <= 1) return;
      // Pure anchor on same page
      var id = href.slice(1);
      var el = document.getElementById(id);
      if (el) {
        e.preventDefault();
        el.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  /* ── Init ──────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initMobileMenu();
    initQuoteForm();
    initSmoothScroll();
  });

})();
